import { Component } from '@angular/core';
import { ModelosService } from '../services/modelos.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-nav-header',
  standalone: false,
  templateUrl: './nav-header.component.html',
  styleUrl: './nav-header.component.css'
})
export class NavHeaderComponent {
  modelos:any=[];
  constructor(private modelo: ModelosService){
    this.modelo.getAll().pipe(first()).subscribe(
        data => {
         this.modelos = data.camiones;
        }
      );
  }
}
